export const LOAD_OPERATIONS_DATA='LOAD_OPERATIONS_DATA';
export const LOAD_CONSUMER_API_DATA='LOAD_CONSUMER_API_DATA';
export const LOAD_DATAQUEST_DATA='LOAD_DATAQUEST_DATA';
export const LOAD_SHOGUN_DATA='LOAD_SHOGUN_DATA';
export const LOAD_MONITORING_DATA='LOAD_MONITORING_DATA';
export const LOAD_ADMIN_STATUSES_DATA='LOAD_ADMIN_STATUSES_DATA';


export const helpText = {
  hard_drive: 'Hard Drive space remaining (%)',
  delayed_job: 'Background Jobs used to delay operational data creation. For example Audits.',
  cron_job: 'Scheduled background jobs which are used to run particular task at specified time. For example exporting data to the client every night.',
  mysql_service: 'MySQL Service is to up and running Database',
  mongo_service: 'MongoDB Service is to up and running Database',
  pg_service: 'PostgresSQL Service is to up and running Database'
}


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/constants.js